let prefix = '/api/sap/whseJournal';
function load_whse_journal_by_date(data) {
    return window.axios.get(prefix + '/byDate', { params: data });
}

function load_document_by_date(data) {
    return window.axios.post( prefix + '/excel/byDate', data, {
         responseType: 'blob' }
    );
}

export default {
    load_whse_journal_by_date,
    load_document_by_date
}